module.exports = __webpack_public_path__ + "static/media/sidebar-8.67644fa1.jpg";